import useSWR from 'swr'

import { defaultPreferences } from 'core/remodel/types/user'
import { fetchCurrentPreferences, userQuery } from '@/api/AccountService'
import { useAuthStore } from '@/store/authStore'

export function useUserPreferences() {
  const database = useAuthStore((state) => state.database)
  const { data: preferences = defaultPreferences, isLoading: isLoadingPreferences } = useSWR(
    [userQuery.currentPreferences],
    fetchCurrentPreferences(database!)
  )

  return { preferences, isLoadingPreferences }
}
